import {css} from "styled-components"

import {largeCss, smallCss} from "./sizesCss"
import {ButtonCssProps} from "./index"

const tertiaryCss = css<ButtonCssProps>`
  ${({theme, inverted, large, small, cta}) => css`
    /* stylelint-disable no-duplicate-selectors */
    color: ${theme.colors.primary2};
    border: none;
    background-color: transparent;
    border-radius: 0;
    transition: all 0.25s ease;
    font-family: ${theme.font.bold};

    /* Size needed for css usage on Links */
    line-height: 16px;
    font-size: 14px;
    letter-spacing: 0.25px;

    ${large && largeCss}
    ${small && smallCss}

    padding: 0;
    /* the 2 lines below allow for spacing to be between the button copy and the box-shadow underline
       without messing up with positioning */
    padding-bottom: ${theme.spacing.half};
    margin-bottom: -${theme.spacing.half};

    path {
      fill: ${theme.colors.primary2};
    }

    ${cta &&
    `
      color: ${theme.colors.primary1};
      path {
        fill: ${theme.colors.primary1};
      }
    `}

    &:hover, &:focus, &:active {
      text-decoration: none;
      color: ${theme.colors.primary2};
      box-shadow: 0px 2px 0px ${theme.colors.primary2};
      background-color: transparent;
      path {
        fill: ${theme.colors.primary2};
      }
      ${cta &&
      `
        color: ${theme.colors.primary1};
        box-shadow: 0px 2px 0px ${theme.colors.primary1};
        path {
          fill: ${theme.colors.primary1};
        }
      `}
    }

    &:disabled,
    &.disabled {
      color: ${theme.colors.primary2_100};
      background-color: transparent;
      border: none;
      path {
        fill: ${theme.colors.primary2_100};
      }
      &:hover,
      &:focus,
      &:active {
        box-shadow: none;
        path {
          fill: ${theme.colors.primary2_100};
        }
      }
    }
    ${inverted &&
    css`
      color: ${theme.colors.utility.white};
      path {
        fill: ${theme.colors.utility.white};
      }
      &:hover,
      &:active,
      &:focus {
        color: ${theme.colors.utility.white};
        box-shadow: 0px 2px 0px ${theme.colors.utility.white};
        background-color: transparent;
        path {
          fill: ${theme.colors.utility.white};
        }
      }
      &:disabled,
      &.disabled {
        color: ${theme.colors.primary2_200};
        border: none;
        box-shadow: none;
        path {
          fill: ${theme.colors.primary2_200};
        }
        &:hover,
        &:focus,
        &:active {
          box-shadow: none;
          path {
            fill: ${theme.colors.primary2_200};
          }
        }
      }
    `}
  `}
`

export default tertiaryCss
